export default {
    name: 'constant',
    // BASE_API_URL : 'https://164.52.198.64:5010/',
    BASE_API_URL : 'https://test4.services-money91.com/parttime/',
    // BASE_API_URL : 'https://partimebe.services-money91.com/',
    USERINFO_URL: "https://dev1.money91.com/redis/",
    FILE_UPLOAD_URL : 'https://test4.services-money91.com/upload_file/',
    GETTEXT: {
        "order_accepted": "Order Accepted"
    },
    PINCODE_REGEX : '/^[1-9][0-9]{5}$/g',
    ALPHABET_REGEX : '/^[a-zA-Z ]*$/g',
    MOBILE_REGEX : '/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g',
    ADDRESS_REGEX : "/[A-Za-z0-9'.-\s,]$/g"

}